// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--836ae";
export var icon = "main-module--icon--dbcd7";
export var sm = "main-module--sm--807fd";
export var xl = "main-module--xl--1a59e";